//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { BCarousel, BCarouselSlide } from 'bootstrap-vue'

import { validationMixin } from 'vuelidate'
import {email, required, minLength, maxLength} from "vuelidate/lib/validators"

export default {

    name: 'ProductDetailPopup',

    mixins: [validationMixin],

    components: { BCarousel, BCarouselSlide },

    props: {
        product: {
            type: Object,
            default: {}
        },
    },

    data() {
        return {
            slide: 0,
            showRequestForm: false,
            name: '',
            email: '',
            message: '',
        }
    },

    validations: {

        name: {
            required
        },
        email: {
            required,
            email
        },
        message: {
            required,
            maxLength: maxLength(2500)
        },


    },

    methods: {

        nl2br(str, is_xhtml) {
            return this.$helper.nl2br(str, is_xhtml)
        },

        closePopup() {
            this.requestFormHide()
            this.$emit('closePopup')
        },

        requestFormShow() {
            this.showRequestForm = true
        },

        requestFormHide() {
            this.showRequestForm = false
            this.resetRequestForm()
        },

        validate() {

            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$toast.global.my_error({message: 'Please fill all required fields'})
                return false
            }

            return true
        },

        sendRequest() {

            const validated = this.validate()

            if(validated === false)  {
                return false
            }

            let _this = this
            const formData = {
                name: this.name,
                email: this.email,
                message: this.message
            }

            this.$axios.post(this.$ziggy.route('profile.products.request.send', {'product': this.product.id}), formData)
                .then((response) => {
                    _this.$toast.global.my_success({message: 'Request send.'})
                    _this.requestFormHide()
                })
                .catch((e) => {
                    this.$toast.global.my_error()
                    _this.$logger.captureException(e)
                })

        },

        resetRequestForm() {
            this.name = ''
            this.email = ''
            this.message = ''
            this.$v.$reset()
        }

    },

    computed: {

        hasProduct() {

            if(this.$helper.empty(this.product)) {
                return false
            }

            return true
        },

        requestFormContentName() {
            return 'ProductPopup: directory'
        },

    }

}

